// ── The web app's share viewer ───────────────────────────────────────────────
//
// `plweb.eeighttech.com` is the signed-in Pocket Ledger web app, and its
// `/view?guid=` route is the one public page it serves. The service's share-link
// routes already mint that URL, so anything else that has to show a shared
// document in a browser — an old message, a universal-link fallback — belongs
// there rather than here. This host was the old destination and now only
// forwards.

export const PLWEB_ORIGIN = "https://plweb.eeighttech.com";

/**
 * The viewer for one shared document, or null when there is no number to show.
 *
 * No shape check on the number: the viewer answers "Document not found" for a
 * token that resolves to nothing, which is a better page than a landing-site
 * error card, and it is the same page the app's own links open.
 */
export function plwebViewUrl(number: string | undefined): string | null {
	const trimmed = (number ?? "").trim();
	if (!trimmed) return null;
	return `${PLWEB_ORIGIN}/view?guid=${encodeURIComponent(trimmed)}`;
}
